import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/SingleAiReport'
import { actions as actionsModal } from 'appRedux/modules/Modal'
import { AiAnswer as component } from './AiAnswer'


const mapStateToProps = (state, ownProps) => {
	const { singleKey, category, subcategory, option, type } = ownProps;
	const subcategoryUpdated = subcategory ?? option.single_data_type;
	const qa = state[`SingleAi${type}`].qa;
	const dayType = state.SingleAiReport.day_type;
	const dayTypeData = (dayType && (subcategoryUpdated in dayType)) ? dayType[subcategoryUpdated] : 'day';
	const qaData = (subcategoryUpdated in qa)
		? qa[subcategoryUpdated]
		: `${singleKey}:${category}:${subcategoryUpdated}` in qa
			? qa[`${singleKey}:${category}:${subcategoryUpdated}`]
			: {};
			
	return {
		subcategory: subcategoryUpdated,
		day_type: dayTypeData,
		qa: qaData,
	};
};
const mapDispatchToProps = (dispatch, ownProps) => {
	const subcategory = ownProps.option.single_data_type;

	return {
		onDayTypeSet: (dayType) => dispatch(actions.setDayType(dayType, subcategory)),
		onModalToggle: (id, open) => dispatch(actionsModal.toggleModal(id, open)),
	};
}
const AiAnswer = connect(mapStateToProps, mapDispatchToProps)(component);


export { AiAnswer }
